import { CommonModule } from '@angular/common';
import { Component,Inject } from '@angular/core';
import { FormControl,ReactiveFormsModule } from '@angular/forms';
import { MatLegacyDialogConfig as MatDialogConfig,MatLegacyDialogModule as MatDialogModule,MatLegacyDialogRef,MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MaterialAmountType } from '@dave/types/dist/proto/erp/warehouseMovements';
import { Actions,ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { BehaviorSubject,combineLatest,firstValueFrom,Observable } from 'rxjs';
import { map, skip, tap, withLatestFrom } from 'rxjs/operators';
import {
    AccountsReceivableLedgerEntity,
    AccountsReceivableLedgerTypeEnum,
    financialRound,
} from '../../../dave-data-module/entities/accounts-receivable-ledger.entity';
import { CommissionEntity } from '../../../dave-data-module/entities/commission.entity';
import {
    LedgerImportDocumentTypeNames,
    LedgerImportDocumentTypes,
    LedgerImportEntity,
    LedgerImportStatusEnum,
} from '../../../dave-data-module/entities/ledger-import.entity';
import { CommissionResolver } from '../../../dave-data-module/guards/commission.resolver';
import { getFetched$ } from '../../../dave-data-module/helper/helper';
import { ArlDataService } from '../../../dave-data-module/services/arl-data.service';
import { MaterialDataService } from '../../../dave-data-module/services/material-data.service';
import { State } from '../../../dave-data-module/State';
import { LedgerImportActionTypes } from '../../../dave-data-module/State/actions/accounting.actions';
import { BaseActionTypes } from '../../../dave-data-module/State/actions/base.actions';
import { WarehouseMovementActionTypes } from '../../../dave-data-module/State/actions/warehouse-movement.actions';
import { getCommissionById,getCommissionDictionary,getCommissionsActive,getCommissionsFetched } from '../../../dave-data-module/State/selectors/commission.selector';
import { getDefaultVat } from '../../../dave-data-module/State/selectors/partners.selectors';
import { ARL_DEFAULT_VALUES } from '../../../dave-reports/components/arl-calculation/arl-calculation.helper';
import { AppButtonModule } from '../../../dave-utils-module/app-button-module/app-button.module';
import { AppDialogService } from '../../../dave-utils-module/app-dialog-module/app-dialog.service';
import { SelectSearchOption } from '../../../dave-utils-module/select-search/components/select-search/select-search.component';
import { SelectSearchModule } from '../../../dave-utils-module/select-search/select-search.module';
import { appMatDialogDefaultConfig } from '../../../helper/helper';
import { CustomLabelService } from '../../../services/custom-label/custom-label.service';
import { LoadingService } from '../../../services/loading.service';
import { AccountsReceivableLedgerPostType } from '../../../dave-data-module/graphql-types';
import { Dictionary } from '@ngrx/entity';

export type ConfirmWarehouseMovementDialogComponentDialogReturnData = undefined | { created: true; routeToDeliveryNote: boolean; deliveryNote?: number };
export interface ConfirmWarehouseMovementDialogComponentDialogData {
    defaultCommissionId?: number;
    materials: { materialId: number; quantity: number; quantityTypeId: number | null, commissionId?: number; commissionAuftragsNummer?: string; type: MaterialAmountType.MaterialAmountTypeInput | MaterialAmountType.MaterialAmountTypeOutput }[];
    ledgerImportId?: number;
    customerIdForNewLedgerImports?: number;
}
@Component({
    selector: 'app-confirm-warehouse-movement-dialog',
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatFormFieldModule, SelectSearchModule, ReactiveFormsModule, AppButtonModule],
    templateUrl: './confirm-warehouse-movement-dialog.component.html',
    styleUrls: ['./confirm-warehouse-movement-dialog.component.scss'],
})
export class ConfirmWarehouseMovementDialogComponent {
    public static DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        minWidth: '24rem',
    };
    public commissionForm = new FormControl<{ Id: number }>(null);
    headline = 'Wareneingang / Warenausgang anlegen';
    protected warehouseMovementTypeLabel = 'Wareneingang / Warenausgang';
    private readonly ledgerImportId: number;
    protected materials: { materialId: number; quantity: number; quantityTypeId: number | null; commissionId?: number;  type: MaterialAmountType.MaterialAmountTypeInput | MaterialAmountType.MaterialAmountTypeOutput }[];
    protected ledgerimportsCreated$ = new BehaviorSubject(false);
    compareById = (a: SelectSearchOption<{ Id: number }>, b: SelectSearchOption<{ Id: number }>) => a?.Id === b?.Id;
    protected allMaterialsHaveCommissionId: boolean;
    protected commissionOptions$: Observable<CommissionEntity[]>;
    // protected materialsGroupedByCommissionId: { [commissionId: number]: { materialId: number; quantity: number }[] };
    protected commissionsWithMaterials: {
        materials: { materialId: number; quantity: number; quantityTypeId: number | null; type: MaterialAmountType.MaterialAmountTypeInput | MaterialAmountType.MaterialAmountTypeOutput }[];
        commissionId: number;
        commission$: Observable<CommissionEntity>;
    }[];
    protected materialsWithoutCommissionId: { materialId: number; quantity: number; quantityTypeId: number | null; commissionAuftragsNummer?: string; type: MaterialAmountType.MaterialAmountTypeInput | MaterialAmountType.MaterialAmountTypeOutput }[];
    protected materialsWithoutCommissionIdGrouped: {
        commissionAuftragsNummer: string;
        materials:  { materialId: number; quantity: number; quantityTypeId: number | null; commissionAuftragsNummer?: string; type: MaterialAmountType.MaterialAmountTypeInput | MaterialAmountType.MaterialAmountTypeOutput }[];
    }[] = [];
    commissionForms: { [commissionAuftragsNummer: string]: FormControl } = {};
    private readonly customerIdForNewLedgerImports: number;
    constructor(
        @Inject(MAT_DIALOG_DATA) dialogData: ConfirmWarehouseMovementDialogComponentDialogData,
        private store: Store<State>,
        commissionResolver: CommissionResolver,
        protected ls: LoadingService,
        private actions$: Actions,
        private arlDataService: ArlDataService,
        private materialDataService: MaterialDataService,
        private appDialog: AppDialogService,
        private dialogRef: MatLegacyDialogRef<ConfirmWarehouseMovementDialogComponent>,
        protected cls: CustomLabelService,
    ) {
        if (dialogData?.defaultCommissionId) {
            this.commissionForm.setValue({ Id: dialogData.defaultCommissionId });
        }
        if (dialogData?.customerIdForNewLedgerImports) {
            this.customerIdForNewLedgerImports = dialogData.customerIdForNewLedgerImports;
        }

        if (dialogData?.materials) {
            if (dialogData.materials.every((m) => m.type === MaterialAmountType.MaterialAmountTypeInput)) {
                this.headline = 'Wareneingang anlegen';
                this.warehouseMovementTypeLabel = 'Wareneingang';
            } else if (dialogData.materials.every((m) => m.type === MaterialAmountType.MaterialAmountTypeOutput)) {
                this.headline = 'Warenausgang anlegen';
                this.warehouseMovementTypeLabel = 'Warenausgang';
            }
            this.materials = dialogData.materials.slice();
            this.allMaterialsHaveCommissionId = this.materials.every((m) => m.commissionId);
            const materialsGroupedByCommissionId: { [key: number]: { materialId: number; quantity: number; commissionId?: number; type: MaterialAmountType.MaterialAmountTypeInput | MaterialAmountType.MaterialAmountTypeOutput }[] } = {};
            this.materialsWithoutCommissionId = [];
            this.materials.forEach((m) => {
                if (!m.commissionId) {
                    this.materialsWithoutCommissionId.push(m);
                } else {
                    if (!materialsGroupedByCommissionId[m.commissionId]) {
                        materialsGroupedByCommissionId[m.commissionId] = [];
                    }
                    materialsGroupedByCommissionId[m.commissionId].push(m);
                }
            });
            this.commissionsWithMaterials = Object.keys(materialsGroupedByCommissionId).map((key) => ({
                commission$: getFetched$(store, getCommissionsFetched, getCommissionById({ id: +key })),
                commissionId: +key,
                materials: materialsGroupedByCommissionId[key],
            }));
        }
        if (dialogData?.ledgerImportId) {
            this.ledgerImportId = dialogData.ledgerImportId;
        }
        this.commissionOptions$ = getFetched$(store, getCommissionsFetched, getCommissionsActive, commissionResolver).pipe(
            withLatestFrom(store.select(getCommissionDictionary)),
            map(([activeCommissions, commissionDict]) => {
                const defaultCommission = dialogData.defaultCommissionId ? commissionDict[dialogData.defaultCommissionId] : null;
                return defaultCommission && !activeCommissions.some((c) => c.Id === defaultCommission.Id) ? [defaultCommission, ...activeCommissions] : activeCommissions;
            }),
        );


        const groups = this.materialsWithoutCommissionId.reduce((acc, material) => {
            const key = material.commissionAuftragsNummer || 'Ohne Auftragsnummer';
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(material);
            return acc;
        }, {} as Record<string, typeof this.materialsWithoutCommissionId>);

        this.materialsWithoutCommissionIdGrouped = Object.entries(groups).map(([commissionAuftragsNummer, materials]) => ({
            commissionAuftragsNummer,
            materials
        }));
        this.materialsWithoutCommissionIdGrouped.forEach(group => {
            this.commissionForms[group.commissionAuftragsNummer] = new FormControl(null);
        });

    }

    getButtonText(): string {
        const liCount = this.getLICount();
        const reLiCount = this.getReLiCount();

        let text = '';
        if (liCount > 0) {
            text += liCount === 1 ? 'Lieferschein erstellen' : `${liCount} Lieferscheine erstellen`;
        }
        if (reLiCount > 0) {
            if (text) text += ' und ';
            text += reLiCount === 1 ? 'Retourenlieferschein erstellen' : `${reLiCount} Retourenlieferscheine erstellen`;
        }
        return text;
    }

    getReLiCount(){
        return this.getLedgerImportsToCreate().filter(l => l.liType == LedgerImportDocumentTypes.ReturnDeliveryNote).length;
    }
    getLICount() {
        return this.getLedgerImportsToCreate().filter(l => l.liType == LedgerImportDocumentTypes.DeliveryNote).length;
    }
    submit() {
        this.ls.startLoading('app-confirm-warehouse-movement-dialog-submit-warehouse-movement');
        // this.ls.startLoading('app-confirm-warehouse-movement-dialog-submit-ledger-import');
        // todo auf alle lis und warehousemovements warten
        let error = false;
        firstValueFrom(
            this.actions$.pipe(ofType(LedgerImportActionTypes.UpdateAll, BaseActionTypes.ErrorAction),tap(action => {
                if (action.type === BaseActionTypes.ErrorAction.type) {
                    error = true;
                }
            }), skip(this.getLICount() - 1)),
        ).then((ledgerImportAction) => {
            this.ls.endLoading('app-confirm-warehouse-movement-dialog-submit-warehouse-movement');
            if (!error) {
                this.ledgerimportsCreated$.next(true);
                if (this.getLICount() === 1) {
                    this.appDialog
                        .OpenConfirmationDialog({
                            heading: `${LedgerImportDocumentTypeNames.get(LedgerImportDocumentTypes.DeliveryNote)} anzeigen?`,
                            paragraph: '',
                            noButton: 'nein',
                        })
                        .subscribe((ret) => {
                            if (ret && ret[0]) {
                                const liId = (ledgerImportAction.Payload as LedgerImportEntity[]).reduce((highestId, entity) => (entity.Id > highestId ? entity.Id : highestId), -1);
                                this.dialogRef.close({ created: true, routeToDeliveryNote: true, deliveryNote: liId });
                            }
                        });
                }
            }
        });
        // warehouseMoveMents werden jetzt vom Backend beim lieferschein auf gebucht setzen angelegt
        // console.log(this.materials);
        // const matIn = this.materials.filter((m) => m.type === MaterialAmountType.MaterialAmountTypeInput);
        // const matOut = this.materials.filter((m) => m.type === MaterialAmountType.MaterialAmountTypeOutput);
        // if (matIn.length) {
        //     this.store.dispatch(
        //         WarehouseMovementActionTypes.CreateRequest({
        //             Payload: {
        //                 Type: MaterialAmountType.MaterialAmountTypeInput,
        //                 // DocumentId: ,
        //                 LegerImportId: this.ledgerImportId ? this.ledgerImportId.toString() : undefined,
        //                 MaterialAmounts: this.materials.reduce((prev, curr) => {
        //                     prev[curr.materialId.toString()] = curr.quantity.toString();
        //                     return prev;
        //                 }, {}),
        //             },
        //         }),
        //     );
        // }
        // if (matOut.length) {
        //     this.store.dispatch(
        //         WarehouseMovementActionTypes.CreateRequest({
        //             Payload: {
        //                 Type: MaterialAmountType.MaterialAmountTypeOutput,
        //                 // DocumentId: ,
        //                 LegerImportId: this.ledgerImportId ? this.ledgerImportId.toString() : undefined,
        //                 MaterialAmounts: this.materials.reduce((prev, curr) => {
        //                     prev[curr.materialId.toString()] = curr.quantity.toString();
        //                     return prev;
        //                 }, {}),
        //             },
        //         }),
        //     );
        // }
        firstValueFrom(this.materialDataService.getMaterialsById$(this.materials.map((m) => m.materialId))).then(async (materials) => {

            const vat = await firstValueFrom(this.store.select(getDefaultVat));
            return Promise.all(
                this.getLedgerImportsToCreate().map((x) =>
                    this.arlDataService
                        .addArls(
                            x.materials.map((mq) => {
                                const m = materials.find((m) => m.Id === mq.materialId);
                                return {
                                    ...ARL_DEFAULT_VALUES,
                                    bookingText: m.ARLValues.BookingText,
                                    information: m.ARLValues.Information,
                                    // die Einheit aus dem Dokument verwenden, wenn vorhanden, ansonssten aus den Stammdaten
                                    quantityTypeId: mq.quantityTypeId || m.ARLValues.QuantityTypeId,
                                    quantity: mq.quantity || 0,
                                    baseCost: financialRound(m.Cost / 100) || 0,
                                    costAmount: financialRound(m.Cost / 100) || 0,
                                    tax: vat,
                                    materialId: m.Id,
                                    itemNumber: AccountsReceivableLedgerEntity.autogenerateItemNumber,
                                    type: AccountsReceivableLedgerTypeEnum.MaterialArl,
                                };
                            }),
                        )
                        .then((arls) => {
                            this.store.dispatch(
                                LedgerImportActionTypes.AddLedgerImportWithDefaults({
                                    Payload: {
                                        commissionId: x.commissionId,
                                        accountsReceivableLedgerIds: arls.map((a) => a.Id),
                                        documentType: x.liType,
                                        customerId: this.customerIdForNewLedgerImports,
                                        status:  LedgerImportStatusEnum.Gebucht,
                                        automaticInvoiceId: true,
                                        // customerId?: number;
                                        // ledgerImportId?: number;
                                        // partnerOfficeId?: number;
                                        // eventId?: number;
                                    },
                                    ARLsForCalculateAmountFromArlIds: arls.reduce((dict, arl) => {
                                        dict[arl.Id] = arl;
                                        return dict;
                                    },{} as Dictionary<AccountsReceivableLedgerEntity>)
                                }),
                            );
                        }),
                ),
            );
        });
    }
    getLedgerImportsToCreate() {
        const lisToCreate: {
            materials: {
                materialId: number;
                quantity: number;
                quantityTypeId: number | null;
            }[];
            liType: LedgerImportDocumentTypes;
            commissionId: number | null;
        }[] = [];
        this.commissionsWithMaterials.forEach((cm) => {
            const matIn = cm.materials.filter((m) => m.type === MaterialAmountType.MaterialAmountTypeInput);
            const matOut = cm.materials.filter((m) => m.type === MaterialAmountType.MaterialAmountTypeOutput);
            if (matIn.length) {
                lisToCreate.push({
                    materials: matIn,
                    liType: LedgerImportDocumentTypes.ReturnDeliveryNote,
                    commissionId: cm.commissionId,
                });
            }
            if (matOut.length) {
                lisToCreate.push({
                    materials: matOut,
                    liType: LedgerImportDocumentTypes.DeliveryNote,
                    commissionId: cm.commissionId,
                });
            }
        });
        if (!this.allMaterialsHaveCommissionId) {
            this.materialsWithoutCommissionIdGrouped.forEach(group => {
                const matIn = group.materials.filter(m => m.type === MaterialAmountType.MaterialAmountTypeInput);
                const matOut = group.materials.filter(m => m.type === MaterialAmountType.MaterialAmountTypeOutput);

                const commissionId = this.commissionForms[group.commissionAuftragsNummer]?.value?.Id;

                if (matIn.length) {
                    lisToCreate.push({
                        materials: matIn,
                        liType: LedgerImportDocumentTypes.ReturnDeliveryNote,
                        commissionId,
                    });
                }
                if (matOut.length) {
                    lisToCreate.push({
                        materials: matOut,
                        liType: LedgerImportDocumentTypes.DeliveryNote,
                        commissionId,
                    });
                }
            });
        }
        return lisToCreate;
    }
}
